export const availableRangesViewContextInitValue = {
  data: {
    availableRanges: [],
    page: 1,
    rowsPerPage: 10,
    totalAvailableRanges: 0,
    expandView: true,
    expandDirection: 'up',
    isLoading: false,
  },
  actions: {
    handleChangeExpandView: () => {},
    handleClickRange: () => {},
    handleChangePage: () => {},
    handleChangeRowsPerPage: () => {},
  },
};
